"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.avatarMenuItems = void 0;
exports.avatarMenuItems = [
    {
        label: 'logout',
        icon: 'pi pi-sign-out',
    },
];
